import React, { useState, useEffect } from 'react';
import { findIndex, find } from 'lodash';

import Header from './Header';
import { HighSchoolStandingsCard } from '../../../../cards';

import styles from './highSchoolStandings.scss';

const _ = { findIndex, find };

const HighSchoolStandings = (props) => {
    const {
        clubDetails,
        highSchoolStandingsSeasons,
        highSchoolStandings,
        highSchoolStandingsState,
        getHighSchoolStandingsSeasons,
        getHighSchoolStandings,
    } = props;

    const [selectedSeason, setSelectedSeason] = useState(null);
    const [toShowStandingsCount, setToShowStandingsCount] = useState(3);

    useEffect(() => {
        getHighSchoolStandingsSeasons({ clubId: props.clubDetails.id });
    }, []);

    useEffect(() => {
        if (highSchoolStandingsSeasons.length > 0) {
            setSelectedSeason(highSchoolStandingsSeasons[0]);
        }
    }, [highSchoolStandingsSeasons]);

    useEffect(() => {
        if (selectedSeason) {
            getHighSchoolStandings({ clubId: props.clubDetails.id, seasonYear: selectedSeason });
        }
    }, [selectedSeason]);

    const handleSeasonChange = (e) => {
        setSelectedSeason(parseInt(e.target.value));
    };

    const handleShowAll = (showAll) => {
        if (showAll) {
            setToShowStandingsCount(highSchoolStandings.length);
        } else {
            setToShowStandingsCount(3);
        }
    };

    const getStandingsToShow = () => {
        const standingsToShow = [];
        if (highSchoolStandings && highSchoolStandings.length) {
            highSchoolStandings.forEach((standing, i) => {
                if (i < toShowStandingsCount) {
                    standingsToShow.push(standing);
                }
            });
            const clubId = props.clubDetails.id;

            if (_.findIndex(standingsToShow, { clubId }) === -1) {
                const currentHsStanding = _.find(highSchoolStandings, { clubId });
                standingsToShow.push(currentHsStanding);
            }
        }
        return standingsToShow;
    };

    const getSeasonYearDisplay = (year) => {
        return `${year} - ${(year % 1000) + 1}`;
    };

    let gridLayout = ['0.5fr', '0.5fr', '2fr', '1fr', '1fr', '1fr', '1fr'];
    const clubSubType = clubDetails?.clubSubType?.value;
    const showBoysP6 = clubSubType === 'mixed' || clubSubType === 'mens';
    const showGirlsP6 = clubSubType === 'mixed' || clubSubType === 'womens';

    if (!showBoysP6 || !showGirlsP6) {
        gridLayout = ['0.5fr', '0.5fr', '3fr', '1fr', '1fr', '1fr'];
    }

    return (
        <>
            {highSchoolStandingsState.loading && (
                <>
                    Loading Team Standings
                </>
            )}
            {!highSchoolStandingsState.loading && !highSchoolStandingsState.successful && (
                <>
                    {highSchoolStandingsState.errorMessage && (
                        <div className={`${styles.unsuccessfulStandingsRetrieval}`}>
                            Unable to retrieve Team Standings
                        </div>
                    )}
                    {!highSchoolStandingsState.errorMessage && (
                        <div className={`${styles.unsuccessfulStandingsRetrieval}`}>
                            No standings to display
                        </div>
                    )}
                </>
            )}
            {!highSchoolStandingsState.loading && highSchoolStandingsState.successful && (
                <>
                    <h6>Team Standings</h6>
                    <div className="form-inline mb16">
                        <div className={`d-flex align-items-center justify-content-center`}>
                            <label className="text-uppercase mt12 mr16">Season</label>
                            <div className="input-wrapper mr8">
                                <select
                                    className="form-control form-control-sm"
                                    value={selectedSeason}
                                    onChange={handleSeasonChange}
                                >
                                    {highSchoolStandingsSeasons && highSchoolStandingsSeasons.length && (
                                        <>
                                            {highSchoolStandingsSeasons.map(season => {
                                                return <option key={season} value={season}>{getSeasonYearDisplay(season)}</option>;
                                            })}
                                        </>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {highSchoolStandings && (
                <>
                    {highSchoolStandings.length > 0 && (
                        <>
                            <div className="d-none d-md-block">
                                <Header
                                    gridLayout={gridLayout}
                                    showBoysP6={showBoysP6}
                                    showGirlsP6={showGirlsP6}
                                />
                            </div>
                            {getStandingsToShow().map((standings, i) => {
                                return (
                                    <HighSchoolStandingsCard
                                        key={`highschool-standings-${i}`}
                                        {...standings}
                                        currentClubId={props.clubDetails.id}
                                        gridLayout={gridLayout}
                                        showBoysP6={showBoysP6}
                                        showGirlsP6={showGirlsP6}
                                    />
                                );
                            })}
                            <div className="mt32">
                                {toShowStandingsCount < highSchoolStandings.length && (
                                    <a href="#" className="underline" onClick={() => { handleShowAll(true); }}>
                                        Show all
                                    </a>
                                )}
                                {toShowStandingsCount >= highSchoolStandings.length && toShowStandingsCount > 3 && (
                                    <a href="#" className="underline" onClick={() => { handleShowAll(false); }}>
                                        Show less
                                    </a>
                                )}
                            </div>
                        </>
                    )}
                    {highSchoolStandings.length === 0 && (
                        <div className="text-center mt48">
                            No standings to display
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default HighSchoolStandings;
